@if (hasCustomTrigger()) {
  <div
    cdkOverlayOrigin
    #origin="cdkOverlayOrigin"
    (click)="toggle()"
    class="inline-flex"
  >
    <ng-content select="[etAtomsMenuTrigger]" />
  </div>
} @else {
  <button
    type="button"
    cdkOverlayOrigin
    #origin="cdkOverlayOrigin"
    (click)="toggle()"
    [class]="triggerClass()"
    [attr.aria-label]="triggerLabel()"
    aria-haspopup="menu"
    [attr.aria-expanded]="isOpen()"
  >
    @if (triggerIcon()) {
      <img [src]="triggerIcon()" alt="" width="20" height="20" class="m-0" />
    }
    @if (triggerLabel()) {
      <span class="text-base font-medium">{{ triggerLabel() }}</span>
    }
  </button>
}

<ng-template
  cdkConnectedOverlay
  cdkConnectedOverlayHasBackdrop
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  [cdkConnectedOverlayOrigin]="origin()!"
  [cdkConnectedOverlayOpen]="isOpen()"
  [cdkConnectedOverlayPositions]="menuPositions"
  [cdkConnectedOverlayOffsetX]="offsetX()"
  [cdkConnectedOverlayOffsetY]="offsetY()"
  (backdropClick)="isOpen.set(false)"
>
  <div
    animate.enter="et-menu-enter"
    animate.leave="et-menu-leave"
    class="card dropdown w-full max-w-md shadow-lg py-2 bg-white rounded-lg overflow-hidden"
    [ngStyle]="{
      width: width(),
      minWidth: minWidth(),
      maxWidth: maxWidth(),
    }"
  >
    <ng-content select="et-atoms-menu-item, [etAtomsMenuItem]" />
  </div>
</ng-template>
